import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/auth/AuthContext";

/** Route wrapper. Redirects to /login when not authenticated. */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-ink-soft">Loading…</div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ returnTo: location.pathname }} replace />;
  }
  return <>{children}</>;
}
